<div class="profile-container">
    <div class="profile-header">
        <div class="header-left">
            <img src="./assets/images/icons/user-red.png" alt="user Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">Profil @if(isEditMode && !showPasswordForm){ / <strong class="username">Modifier les informations du profil</strong> }
                @if(!isEditMode && showPasswordForm){ / <strong class="username">Changer votre mot de passe</strong> }
                </span>
            </span>
        </div>

        <div class="header-right">
            @if(isEditMode){
            <button type="button" class="back-btn" (click)="cancelEdit()">
                <img src="./assets/images/icons/back-arrow.png" alt="back-arrow">
                <span>Retour</span>    
            </button> }
        </div>
    </div>
    <div class="profile-details-container">
        <!-- Loading state -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement des détails du membre...</p>
        </div>

        <!-- Error state -->
        <div *ngIf="!isLoading && errorMessage" class="error-state">
            <div class="error-icon">!</div>
            <p class="error-message">{{ errorMessage }}</p>
        </div>

        <div *ngIf="!isEditMode && !showPasswordForm && !isLoading && customerProfile" class="profile-details">
            <div class="profile-details">
                <div class="profile-details-header">
                    <!-- Menu Button -->
                    <button class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                        <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                    </button>
                </div>
                <div class="profile-details-image">
                    <div class="profile-image-col">
                        <img [src]="customerProfile.profileImage || './assets/images/profile-avatar.png'" [alt]="customerProfile.firstName" class="profile-image" [class.full]="customerProfile.profileImage">
                    </div>
                </div>

                <div class="profile-data">
                    <div class="col-1">
                        <div class="data-row">
                            <img src="./assets/images/icons/profile/user.png" alt="user icon">
                            <div class="content">
                                <span class="label">Nom complet</span>
                                <span class="value">{{ customerProfile.firstName }} {{ customerProfile.lastName }}</span>
                            </div>
                        </div>
                        <div class="data-row">
                            <img src="./assets/images/icons/profile/mail.png" alt="mail icon">
                            <div class="content">
                                <span class="label">Email</span>
                                <span class="value">{{ customerProfile.email }}</span>
                            </div>
                        </div>
                        <div class="data-row">
                            <img src="./assets/images/icons/profile/phone.png" alt="phone icon">
                            <div class="content">
                                <span class="label">Numéro</span>
                                <span class="value">{{ customerProfile.phoneNumber }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="data-row">
                            <img src="./assets/images/icons/profile/marker.png" alt="marker icon">
                            <div class="content">
                                <span class="label">Address</span>
                                <span class="value">{{ formatAddress(customerProfile.address) }}</span>
                            </div>
                        </div>
                        <div class="data-row">
                            <img src="./assets/images/icons/profile/company.png" alt="company icon">
                            <div class="content">
                                <span class="label">Nom complet</span>
                                <span class="value">{{ customerProfile.companyName }}</span>
                            </div>
                        </div>
                        <div class="data-row">
                            <img src="./assets/images/icons/profile/vat.png" alt="vat icon">
                            <div class="content">
                                <span class="label">V.A.T</span>
                                <span class="value">{{ customerProfile.vatNumber }}</span>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            @if(menuOpen()){
            <div class="popup-menu">
                <div class="arrow"></div>
                <ul>
                    <li (click)="toggleEditMode()"><img src="./assets/images/icons/edit.png" alt="modifier"> Modifier</li>
                    <li (click)="togglePasswordForm()"><img src="./assets/images/icons/lock-red.png" alt="lock">Changer mot de passe</li>
                </ul>
            </div>
            }
        </div>

        <div *ngIf="isEditMode && !isLoading" class="profile-image-section">
            <div class="image-container" (click)="fileInput.click()">
                <div *ngIf="previewUrl" class="image-preview">
                    <img [src]="previewUrl" alt="Profile" class="profile-image">
                </div>
                <div *ngIf="!previewUrl" class="image-placeholder">
                    <img src="assets/images/icons/upload.png" alt="Camera" class="camera-icon">
                    <span>cliquer ici pour uploader votre image</span>
                </div>
                <div *ngIf="isEditMode && customerProfile!.profileImage" class="image-overlay">
                    <img src="assets/images/icons/upload.png" alt="Camera" class="camera-icon">
                    <span>cliquer ici pour uploader votre image</span>
                </div>
                <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" class="file-input" hidden>
            </div>

            <div *ngIf="isEditMode && (selectedFile || previewUrl)" class="image-actions">
                <button *ngIf="selectedFile" class="btn-save-image" (click)="updateProfileImage()" [disabled]="isSubmitting">
                    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                    {{ isSubmitting ? 'Enregistrement...' : 'Enregistrer la photo' }}
                </button>
                <button *ngIf="previewUrl" class="btn-remove-image" (click)="deleteProfileImage()" [disabled]="isSubmitting">
                    Supprimer
                </button>
            </div>
        </div>

        <!-- Edit Form -->
        <div *ngIf="isEditMode && !isLoading" class="edit-form-container">
            <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="edit-form">
                <!-- Personal Information -->
                <div class="form-section">
                    <h4 class="section-title">Informations personnelles</h4>
                    <div class="form-row">
                        <div class="form-group">
                            <label for="firstName">Prénom *</label>
                            <input type="text" id="firstName" formControlName="firstName" class="form-control" [class.is-invalid]="firstName?.invalid && firstName?.touched">
                            <div *ngIf="firstName?.invalid && firstName?.touched" class="form-error">
                                <span *ngIf="firstName?.errors?.['required']">Le prénom est obligatoire</span>
                                <span *ngIf="firstName?.errors?.['minlength']">Minimum 2 caractères</span>
                                <span *ngIf="firstName?.errors?.['maxlength']">Maximum 100 caractères</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="lastName">Nom *</label>
                            <input type="text" id="lastName" formControlName="lastName" class="form-control" [class.is-invalid]="lastName?.invalid && lastName?.touched">
                            <div *ngIf="lastName?.invalid && lastName?.touched" class="form-error">
                                <span *ngIf="lastName?.errors?.['required']">Le nom est obligatoire</span>
                                <span *ngIf="lastName?.errors?.['minlength']">Minimum 2 caractères</span>
                                <span *ngIf="lastName?.errors?.['maxlength']">Maximum 100 caractères</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="phoneNumber">Téléphone *</label>
                        <input type="tel" id="phoneNumber" formControlName="phoneNumber" class="form-control" [class.is-invalid]="phoneNumber?.invalid && phoneNumber?.touched" placeholder="Ex: +33 1 23 45 67 89">
                        <div *ngIf="phoneNumber?.invalid && phoneNumber?.touched" class="form-error">
                            <span *ngIf="phoneNumber?.errors?.['required']">Le téléphone est obligatoire</span>
                            <span *ngIf="phoneNumber?.errors?.['pattern']">Format invalide</span>
                        </div>
                    </div>
                </div>

                <!-- Company Information -->
                <div class="form-section">
                    <h4 class="section-title">Informations de l'entreprise (optionnel)</h4>
                    <div class="form-row">
                        <div class="form-group">
                            <label for="companyName">Nom de l'entreprise</label>
                            <input type="text" id="companyName" formControlName="companyName" class="form-control" [class.is-invalid]="companyName?.invalid && companyName?.touched">
                            <div *ngIf="companyName?.invalid && companyName?.touched" class="form-error">
                                <span *ngIf="companyName?.errors?.['maxlength']">Maximum 200 caractères</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="vatNumber">Numéro de TVA</label>
                            <input type="text" id="vatNumber" formControlName="vatNumber" class="form-control" [class.is-invalid]="vatNumber?.invalid && vatNumber?.touched">
                            <div *ngIf="vatNumber?.invalid && vatNumber?.touched" class="form-error">
                                <span *ngIf="vatNumber?.errors?.['maxlength']">Maximum 50 caractères</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Address Information -->
                <div class="form-section" [formGroup]="addressForm">
                    <h4 class="section-title">Adresse</h4>
                    <div class="form-row">
                        <div class="form-group">
                            <label for="streetNumber">Adresse *</label>
                            <input type="text" id="streetNumber" formControlName="streetNumber" class="form-control" [class.is-invalid]="streetNumber?.invalid && streetNumber?.touched" placeholder="Numéro et nom de la rue">
                            <div *ngIf="streetNumber?.invalid && streetNumber?.touched" class="form-error">
                                <span *ngIf="streetNumber?.errors?.['required']">L'adresse est obligatoire</span>
                                <span *ngIf="streetNumber?.errors?.['maxlength']">Maximum 200 caractères</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="street">Complément d'adresse</label>
                            <input type="text" id="street" formControlName="street" class="form-control" [class.is-invalid]="street?.invalid && street?.touched" placeholder="Appartement, étage, bâtiment...">
                            <div *ngIf="street?.invalid && street?.touched" class="form-error">
                                <span *ngIf="street?.errors?.['maxlength']">Maximum 200 caractères</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group">
                            <label for="city">Ville *</label>
                            <input type="text" id="city" formControlName="city" class="form-control" [class.is-invalid]="city?.invalid && city?.touched" placeholder="Ex: Bruxelles">
                            <div *ngIf="city?.invalid && city?.touched" class="form-error">
                                <span *ngIf="city?.errors?.['required']">La ville est obligatoire</span>
                                <span *ngIf="city?.errors?.['maxlength']">Maximum 100 caractères</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="postalCode">Code postal *</label>
                            <input type="text" id="postalCode" formControlName="postalCode" class="form-control" [class.is-invalid]="postalCode?.invalid && postalCode?.touched" placeholder="Ex: 1040">
                            <div *ngIf="postalCode?.invalid && postalCode?.touched" class="form-error">
                                <span *ngIf="postalCode?.errors?.['required']">Le code postal est obligatoire</span>
                                <span *ngIf="postalCode?.errors?.['pattern']">Format invalide (4-10 chiffres)</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Form Actions -->
                <div class="form-actions">
                    <button type="submit" class="btn-primary" [disabled]="isSubmitting || profileForm.invalid">
                        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                        {{ isSubmitting ? 'Enregistrement...' : 'Confirmer' }}
                    </button>
                    <button type="button" class="btn-cancel" (click)="cancelEdit()" [disabled]="isSubmitting">
                        Annuler
                    </button>
                </div>
            </form>
        </div>

        <!-- Edit password -->
        <div *ngIf="showPasswordForm && !isLoading" class="password-section">
            <div *ngIf="showPasswordForm" class="password-form-container">
                <form [formGroup]="passwordForm" (ngSubmit)="onPasswordSubmit()" class="password-form">
                    <div class="form-group mb-4">
                        <label for="currentPassword">Confirmer votre identité pour pouvoire changer votre mot de passe</label>
                        <div class="input-group password-group">
                            <img src="assets/images/icons/lock-red.png" alt="lock-icon" class="input-icon">
                            <input [type]="showPassword ? 'text' : 'password'" id="currentPassword" formControlName="currentPassword" class="form-control" [class.is-invalid]="currentPassword?.invalid && currentPassword?.touched" placeholder="Entrer votre mot de passe actuel">
                            <button type="button" class="password-toggle" (click)="togglePassword('password')">
                                <img src="assets/images/icons/eye.png" alt="eye-icon">
                            </button>
                        </div>

                        <div *ngIf="currentPassword?.invalid && currentPassword?.touched" class="form_error">
                            <span *ngIf="currentPassword?.errors?.['required']">Le mot de passe actuel est obligatoire</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="newPassword">Entrer votre nouveau mot de passe </label>
                        <div class="input-group password-group">
                            <img src="assets/images/icons/lock-red.png" alt="lock-icon" class="input-icon">
                            <input [type]="showConfirmPassword ? 'text' : 'password'" id="newPassword" formControlName="newPassword" class="form-control" [class.is-invalid]="newPassword?.invalid && newPassword?.touched" placeholder="Entrer votre nouveau mot de passe">
                            <button type="button" class="password-toggle" (click)="togglePassword('confirmPassword')">
                                <img src="assets/images/icons/eye.png" alt="eye-icon">
                            </button>
                        </div>
                        <div *ngIf="newPassword?.invalid && newPassword?.touched" class="form_error">
                            <span *ngIf="newPassword?.errors?.['required']">Le nouveau mot de passe est obligatoire</span>
                            <span *ngIf="newPassword?.errors?.['minlength']">Minimum 6 caractères</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group password-group">
                            <img src="assets/images/icons/lock-red.png" alt="lock-icon" class="input-icon">
                            <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" formControlName="confirmPassword" class="form-control" [class.is-invalid]="confirmPassword?.invalid && confirmPassword?.touched" placeholder="Confirmer votre nouveau mot de passe">
                            <button type="button" class="password-toggle" (click)="togglePassword('confirmPassword')">
                                <img src="assets/images/icons/eye.png" alt="eye-icon">
                            </button>
                        </div>
                        <div *ngIf="confirmPassword?.invalid && confirmPassword?.touched" class="form_error">
                            <span *ngIf="confirmPassword?.errors?.['required']">La confirmation est obligatoire</span>
                        </div>
                        <div *ngIf="passwordForm.errors?.['passwordMismatch'] && confirmPassword?.touched" class="form-error">
                            Les mots de passe ne correspondent pas
                        </div>
                    </div>

                    <div *ngIf="passwordError" class="form-error-message">
                        {{ passwordError }}
                    </div>

                    <div class="form-actions">
                        <button type="submit" class="btn-primary" [disabled]="isChangingPassword || passwordForm.invalid">
                            <span *ngIf="isChangingPassword" class="spinner-border spinner-border-sm me-2"></span>
                            {{ isChangingPassword ? 'Mise à jour...' : 'Confirmer' }}
                        </button>
                        <button type="button" class="btn-cancel" (click)="togglePasswordForm()" [disabled]="isChangingPassword">
                            Annuler
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>